export default (() => {
  const localizations = document.getElementById('stage-localizations')?.innerHTML;
  if (localizations) {
    return JSON.parse(localizations);
  }
})();
